const { gql } = require('@apollo/client')

const StaffMemberFragment = gql`
  fragment StaffMember on StaffMember {
    id
    email
    firstName
    isStoreManager
    lastName
    phoneNumber
    title
    profilePicture
    offdates {
      fromDate
      toDate
    }
  }
`

export { StaffMemberFragment }
